import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import { msalConfig } from "./Config/authConfig";
import { Provider } from "react-redux";
import { I18nextProvider } from 'react-i18next';
import { store, persistor } from "./Redux/store";
import { PersistGate } from "redux-persist/integration/react";
import i18n from './i18n';
const msalInstance = new PublicClientApplication(msalConfig);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

 
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <App />
          </I18nextProvider>
        </PersistGate>
      </Provider>
    </MsalProvider>
  
);

